import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from './axios-client';
import {AxiosError} from "axios";
import {ServerResponse} from "../../Types/ServerResponse";
import {ErrorResponse} from "../../Types/ErrorResponse";

interface UserForgotPassword {
    email: string;
}

interface UserForgotPasswordState {
    status: string,
    server_response: ServerResponse,
    error: ErrorResponse
}

const initialState: UserForgotPasswordState = {
    status: '',
    server_response: {},
    error: {}
};

/**
 * Thunk action creator to handle the forgot password functionality.
 *
 * This function sends a request to the backend API to initiate the forgot password process
 * for the specified user email.
 *
 * @param {UserForgotPassword} user - The user object containing the email for forgot password.
 * @param {ThunkAPI} thunkAPI - The Redux thunk API object.
 * @returns {Promise<any>} A promise that resolves with the response data from the backend.
 */
export const userForgotPassword = createAsyncThunk(
    "user/forgot-password",
    async (user: UserForgotPassword, thunkAPI) => {

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/forgot-password`, {
                email: user.email,
            });
            return response.data;
        } catch (_err) {
            const error = _err as AxiosError;
            return thunkAPI.rejectWithValue(error);
        }

    },
);

/**
 * Slice to manage the state related to forgot password functionality.
 *
 * This slice manages the state for initiating the forgot password process,
 * including the forgot password details, status, and server response.
 */
export const ForgotPasswordSlice = createSlice({
    name: "user/forgot-password",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(userForgotPassword.fulfilled, (state, action) => {
            state.server_response = action.payload;
            state.status = "success";
        });
        builder.addCase(userForgotPassword.rejected, (state, action) => {
            state.status = "failed";
            state.error.response = action.payload;
        });
        builder.addCase(userForgotPassword.pending, (state) => {
            state.status = "loading";
        });
    },
});


export const {} = ForgotPasswordSlice.actions;
export default ForgotPasswordSlice.reducer;